export const formatSize = (size) => {
    if (typeof size === 'string') {
        return size;
    }
    return `${size}px`;
};
